import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/material";
import { useState } from "react";
import Flex from "../../../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../../../components/OutlineCard";
import Text from "../../../../../../../../../components/Text";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { CHART_COLORS } from "../../../../../../../../../components/app/provider/patient/chart";

type CardViewProps = {
  titleIcon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  endAction?: React.ReactNode;
  withExpand?: boolean;
};

/**
 * @description CardView component is used to display a card with a title and a content.
 *
 * @author [Rajkumar Rathod]
 */
const CardView = ({
  title,
  titleIcon,
  children,
  endAction,
  withExpand = true,
}: CardViewProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(true);

  return (
    <OutlineCard sx={{ height: "100%", width: "100%", padding: 0 }}>
      <Flex alignItems={"center"} gap={1}>
        <Flex
          justifyContent={"space-between"}
          width={"100%"}
          alignItems={"center"}
          bgcolor={CHART_COLORS.surfaceSubtle}
          p={1}
        >
          <Text mb={1}>
            {titleIcon} {title}
          </Text>
          <Flex gap={1} alignItems={"center"}>
            {endAction}
            {withExpand &&
              (!isOpened ? (
                <ExpandMoreIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setIsOpened(!isOpened)}
                />
              ) : (
                <ExpandLessIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => setIsOpened(!isOpened)}
                />
              ))}
          </Flex>
        </Flex>
      </Flex>
      {isOpened ? <Box p={1}>{children}</Box> : null}
    </OutlineCard>
  );
};

export default CardView;
